import getInspectionTimeSlotOptions from "../../api/inspections/getInspectionTimeSlotOptions";
import { QueryKey, useQuery } from "react-query";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";

export default function useInspectionTimeSlotOptions(id?: string | number) {
  const key = InspectionTimeSlotOptionsQueryKey(id);
  const headers = useNetworkHeaders();

  const query = useQuery(key, getInspectionTimeSlotOptions(Number(id), headers), { enabled: !!id });

  return {
    data: query.data,
  };
}

function InspectionTimeSlotOptionsQueryKey(id?: number | string): QueryKey {
  return ["inspection-time-slot-options", id?.toString()].filter((key) => key);
}
